var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import difference from 'lodash/difference';
import React, { memo, useCallback, useMemo, } from 'react';
import { useIntl } from 'react-intl';
import { matchPath, useLocation, useRouteMatch, } from 'react-router-dom';
import { MultiColumnList } from '@folio/stripes/components';
import { PrevNextPagination, useItemToView, } from '@folio/stripes-acq-components';
import { CLAIMING_LIST_COLUMNS, CLAIMING_LIST_SORTABLE_FIELDS, } from '../../constants';
import { getResultsListFormatter } from '../../utils';
import css from './ClaimingList.css';
var nonInteractiveHeaders = difference(Object.values(CLAIMING_LIST_COLUMNS), Object.values(CLAIMING_LIST_SORTABLE_FIELDS));
var ClaimingList = function (_a) {
    var _b;
    var columnMapping = _a.columnMapping, contentData = _a.contentData, height = _a.height, isEmptyMessage = _a.isEmptyMessage, isLoading = _a.isLoading, onHeaderClick = _a.onHeaderClick, onNeedMoreData = _a.onNeedMoreData, onSelect = _a.onSelect, pagination = _a.pagination, selectedRecordsDict = _a.selectedRecordsDict, sortDirection = _a.sortDirection, sortingField = _a.sortingField, totalCount = _a.totalCount, visibleColumns = _a.visibleColumns, width = _a.width;
    var intl = useIntl();
    var location = useLocation();
    var match = useRouteMatch();
    var _c = useItemToView('claiming-list'), itemToView = _c.itemToView, setItemToView = _c.setItemToView, deleteItemToView = _c.deleteItemToView;
    var urlParams = useMemo(function () { return (matchPath(location.pathname, { path: "".concat(match.path, "/:id/view") })); }, [location.pathname, match.path]);
    var isRowSelected = useCallback(function (_a) {
        var item = _a.item;
        return urlParams ? (urlParams.params.id === item.id) : false;
    }, [urlParams]);
    var formatter = useMemo(function () {
        return getResultsListFormatter({
            disabled: isLoading,
            intl: intl,
            onSelect: onSelect,
            selectedRecordsDict: selectedRecordsDict,
        });
    }, [isLoading, intl, onSelect, selectedRecordsDict]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MultiColumnList, { id: "claiming-list", contentData: contentData, totalCount: totalCount, visibleColumns: visibleColumns, columnMapping: columnMapping, formatter: formatter, getCellClass: function (defaultCellStyle) { return "".concat(defaultCellStyle, " ").concat(css.cellAlign); }, loading: isLoading, onNeedMoreData: onNeedMoreData, sortedColumn: sortingField, sortDirection: sortDirection, onHeaderClick: onHeaderClick, isEmptyMessage: isEmptyMessage, hasMargin: true, height: height - PrevNextPagination.HEIGHT, width: width, isSelected: isRowSelected, itemToView: itemToView, onMarkPosition: setItemToView, onMarkReset: deleteItemToView, pagingType: 'none', stickyFirstColumn: true, columnWidths: (_b = {}, _b[CLAIMING_LIST_COLUMNS.select] = '34px', _b), nonInteractiveHeaders: nonInteractiveHeaders }),
        contentData.length > 0 && (React.createElement(PrevNextPagination, __assign({}, pagination, { totalCount: totalCount, disabled: isLoading, onChange: onNeedMoreData })))));
};
export default memo(ClaimingList);
